import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { useMemo, useState } from 'react'

export default function CustomTimeRangeComponent({ submitTimeRange, closeDialog }) {
  const [startTime, setStartTime] = useState(dayjs().subtract(1, 'days'))
  const [endTime, setEndTime] = useState(dayjs())

  const reportsButtonDisabled = useMemo(() => {
    return !startTime || !endTime || startTime?.isAfter(endTime)
  }, [startTime, endTime])

  return (
    <>
      <DialogTitle>Custom Duration</DialogTitle>
      <DialogContent>
        <div className="d-flex align-items-center gap-3 p-4">
          <DateTimePicker
            inputId={'startDate'}
            maxDate={dayjs().utc()}
            value={dayjs.utc(startTime).local()}
            onChange={(date) => setStartTime(date.utc())}
            defaultValue={dayjs().utc()}
          />
          <span>to</span>
          <DateTimePicker
            inputId={'endDate'}
            maxDate={dayjs().utc()}
            value={dayjs.utc(endTime).local()}
            onChange={(date) => setEndTime(date.utc())}
            defaultValue={dayjs().utc()}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button sx={{ color: 'grey' }} onClick={closeDialog}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={reportsButtonDisabled}
          onClick={() => {
            submitTimeRange(startTime, endTime)
          }}
        >
          Get Reports
        </Button>
      </DialogActions>
    </>
  )
}
